import { lowerCaseKeysObject } from '../../../utility/object.util.service';

export const ASSET_TYPE_VALUES = {
  tool: 'Tool',
  accessory: 'Accessory',
  material: 'Material',
  storage: 'Storage',
  attachment: 'Attachment',
  equipment: 'Equipment',
  gateway: 'Gateway',
};

const getTypeValue = (val) => {
  val = (val || '').toLowerCase();
  return ASSET_TYPE_VALUES[val] || ASSET_TYPE_VALUES.equipment;
};

export class Asset {
  constructor(asset) {
    asset = asset || {};
    Object.keys(asset).forEach((k) => {
      this[k] = asset[k];
    });

    const attrs = lowerCaseKeysObject(asset.attrs);

    this.id = asset.id;
    this.name = asset.name;
    this.make = attrs['make'];
    this.model = attrs['model'];
    this.year = attrs['model year'];
    this.cat = attrs['category'] || '';
    this.class = attrs['class'] || '';
    if (this.cat || this.class) {
      this.catClass = this.cat ? `${this.cat} - ${this.class}` : `${this.class}`;
    }
    if (this.make || this.model) {
      this.makeModel = this.model ? `${this.make} - ${this.model}` : `${this.make}`;
    }
    this.assetType = getTypeValue(attrs['onei3:asset.type']);
    const [lat, lng] = asset.coords || [];
    this.lat = lat;
    this.lng = lng;
    this.coordsAt = asset.coordsAt;
    this.onSite = true;
    this.ccLikeQtyOnSite = undefined;
    this.ccLikeQtyOnSiteUsagePercent = undefined;
    this.onSiteStatus = undefined;
    this.seenIn = undefined;
    this.usedIn = undefined;
    this.usedAt = undefined;
  }
  get lastSeenAgo() {
    return this.coordsAt ? moment(this.coordsAt).fromNow() : '';
  }
  get lastSeenInDays() {
    return this.coordsAt ? moment().diff(moment(this.coordsAt), 'days', true) : undefined;
  }
  get lastUsedAtAgo() {
    return this.usedAt ? moment(this.usedAt).fromNow() : '';
  }
}
